import React, { useState, useCallback } from 'react'
import { makeStyles } from '@material-ui/styles'
import Dropdown from 'core/elements/dropdown'
import IconButton from 'core/elements/button/IconButton'

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: theme.spacing(1),
  },
  dropdown: {
    minWidth: 150,
    '& .inputFrame': {
      borderWidth: 1,
    },
  },
}))

export interface SortFieldOption {
  value: string
  label: string
}

interface VMServerSideSortProps {
  onSort: (sortKey: string, sortDir: 'asc' | 'desc') => void
  isLoading?: boolean
  defaultSortKey?: string
  defaultSortDir?: 'asc' | 'desc'
}

const SORT_FIELD_OPTIONS: SortFieldOption[] = [
  { value: 'created_at', label: 'Created' },
  { value: 'display_name', label: 'Name' },
  { value: 'uuid', label: 'UUID' },
  { value: 'vm_state', label: 'State' },
  { value: 'cluster', label: 'Cluster' },
  { value: 'owner', label: 'Owner' },
  { value: 'host', label: 'Host' },
  { value: 'instance_type_id', label: 'Flavor' },
  { value: 'tenant_id', label: 'Tenant' },
  { value: 'image_ref', label: 'Source Image' },
  { value: 'updated_at', label: 'Updated At' },
  { value: 'launched_at', label: 'Launched At' },
  { value: 'terminated_at', label: 'Terminated At' },
  // { value: 'access_ip_v4', label: 'IPv4 Address' },
  // { value: 'access_ip_v6', label: 'IPv6 Address' },
  // { value: 'power_state', label: 'Power State' },
  // { value: 'task_state', label: 'Task State' },
  // { value: 'key_name', label: 'Key Name' },
  // { value: 'kernel_id', label: 'Kernel ID' },
  // { value: 'ramdisk_id', label: 'Ramdisk ID' },
  // { value: 'root_device_name', label: 'Root Disk Type' },
  // { value: 'launch_index', label: 'Launch Index' },
  // { value: 'node', label: 'Node' },
  // { value: 'progress', label: 'Progress' },
  // { value: 'locked_by', label: 'Locked By' },
  // { value: 'config_drive', label: 'Config Drive' },
  // { value: 'auto_disk_config', label: 'Auto Disk Config' },
  // { value: 'display_description', label: 'Description' },
]

export const VMServerSideSort: React.FC<VMServerSideSortProps> = ({
  onSort,
  isLoading = false,
  defaultSortKey = 'created_at',
  defaultSortDir = 'desc',
}) => {
  const classes = useStyles()
  const [sortKey, setSortKey] = useState<string>(defaultSortKey)
  const [sortDir, setSortDir] = useState<'asc' | 'desc'>(defaultSortDir)

  const handleSortKeyChange = useCallback(
    (value: string) => {
      setSortKey(value)
      onSort(value, sortDir)
    },
    [sortDir, onSort],
  )

  const handleToggleSortDir = useCallback(() => {
    const newDir = sortDir === 'asc' ? 'desc' : 'asc'
    setSortDir(newDir)
    onSort(sortKey, newDir)
  }, [sortKey, sortDir, onSort])

  return (
    <div className={classes.root}>
      <Dropdown
        className={classes.dropdown}
        label="Sort by"
        items={SORT_FIELD_OPTIONS}
        value={sortKey}
        onChange={handleSortKeyChange}
        disabled={isLoading}
      />
      <IconButton
        onClick={handleToggleSortDir}
        disabled={isLoading}
        size="md"
        info={sortDir === 'asc' ? 'Sorted Ascending' : 'Sorted Descending'}
        icon={sortDir === 'asc' ? 'sort-amount-desc' : 'sort-amount-asc'}
      />
    </div>
  )
}

export default VMServerSideSort
